var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({'background': _vm.colors[_vm.colorIndex], 'width': `${_vm.width}%`}),attrs:{"id":"strength"}})
}
var staticRenderFns = []

export { render, staticRenderFns }